export default "__VITE_ASSET__B8T9WcZM__"